angular.module('affiliateCompany', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/affiliate-company/affiliate-company.module.js